@if (loading) {
  <div class="loading-animation">
    <div class="loader-container">
      @if (!error) {
        <mat-progress-spinner diameter="60" mode="indeterminate">
        </mat-progress-spinner>
      }
      @if (error) {
        <mat-icon fontSet="material-symbols-outlined" class="error-icon">video_camera_front_off</mat-icon>
      }
      @if (title && !error) {
        <h1 class="loader-title">{{title}}</h1>
      }
      @if (error) {
        <h1 class="loader-title">{{title ?? 'unknown-error'}}</h1>
      }
    </div>
  </div>
}
